module.exports = __webpack_public_path__ + "static/img/2.3b09d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rootDoc/img/2.png
// module id = yqDz
// module chunks = 1